import {useSelector} from "react-redux";
import {calculateProgress} from "./helpers";
import {Swiper, SwiperSlide} from "swiper/react";
import {memo, useCallback, useEffect, useMemo, useRef} from "react";
import s from './ModalOptionsMobile.module.css';

export const ModalOptionsMobile = memo(({
  isOpen,
  handleClose,
  style,
  getModalContent,
  isFullHeightMobile,
}) => {

  const innerHeight = useSelector(state => state.layout.innerHeight);

  const swiperInstanceRef = useRef(null);
  const containerRef = useRef(null);
  const isUpcomingCloseRef = useRef(false);
  const progressBasedOpacityRef = useRef(0);
  const backgroundRef = useRef(null);

  const handleSwiper = useCallback((swiper) => swiperInstanceRef.current = swiper, []);
  const handleTouchStart = useCallback(() => isUpcomingCloseRef.current = false, [isUpcomingCloseRef]);
  const handleTouchEnd = useCallback(() => isUpcomingCloseRef.current = true, [isUpcomingCloseRef]);

  const handleProgress = useCallback(({translate}) => {
    if (!containerRef.current) return;

    const progress = calculateProgress(translate, containerRef.current?.offsetHeight);

    if (progress !== progressBasedOpacityRef.current) {
      progressBasedOpacityRef.current = progress;

      if (backgroundRef.current) {
        backgroundRef.current.style.opacity = progress;
      }
    }

    if (progress <= 0.02 && isUpcomingCloseRef.current) {
      handleClose();
    }
  }, [containerRef, handleClose, isUpcomingCloseRef, progressBasedOpacityRef]);

  const handleCloseModal = useCallback(() => {
    isUpcomingCloseRef.current = true;
    swiperInstanceRef.current?.slideTo(0);
  }, [swiperInstanceRef, isUpcomingCloseRef]);

  useEffect(() => {
    if (!swiperInstanceRef.current) return;

    if (isOpen) {
      isUpcomingCloseRef.current = false;
      swiperInstanceRef.current?.slideTo(1);
    } else {
      swiperInstanceRef.current?.slideTo(0);
      isUpcomingCloseRef.current = true;
    }
  }, [isOpen, isUpcomingCloseRef, swiperInstanceRef]);

  const memoizedModalContent = useMemo(
    () => getModalContent({handleCloseModal}),
    [getModalContent, handleCloseModal]
  );

  // const {height} = useSizeObserver(containerRef);
  // useEffect(() => {
  //   console.log(height)
  //   if (!swiperInstanceRef.current) return;
  //
  //   const offsetTop = swiperInstanceRef.current?.slides?.[1]?.offsetTop;
  //
  //   if (offsetTop) {
  //     swiperInstanceRef.current.wrapperEl.scrollTo({top: offsetTop, behavior: "instant"});
  //   }
  // }, [height, swiperInstanceRef]);

  return (
    <div className={s.wrapper} style={{height: innerHeight}}>
      <div className={s.fon} ref={backgroundRef}/>
      <Swiper
        allowTouchMove={false}
        className={s.swiper}
        initialSlide={0}
        cssMode={true}
        direction={'vertical'}
        onProgress={handleProgress}
        slidesPerView={'auto'}

        onSwiper={handleSwiper}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <SwiperSlide onClick={handleCloseModal}/>
        <SwiperSlide className={s.container}>
          <div
            ref={containerRef}
            className={s.block}
            style={{
              maxHeight: innerHeight,
              ...(isFullHeightMobile ? {height: innerHeight} : {}),
              ...style
            }}
          >
            {memoizedModalContent}
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
});